export { default } from './Faq';
export * from './Faq';
